import { isNil } from 'ramda';
import { EventMediaFormData } from '~admin/view/components/details/event-details/event-media-details.component';
import { EventProfileCreateRequest } from '~client/model/admin/event-profile-create-request';

/**
 * Transforms EventMediaFormData to Partial<EventProfileCreateRequest>
 * @param values
 */
export const getEventMediaDetailsRequest = (
  values: EventMediaFormData,
): Pick<
  EventProfileCreateRequest,
  'avatarMediaId' | 'defaultMediaId' | 'emailMediaId' | 'mediaIds'
> => {
  const { avatarMedia, defaultMedia, emailMedia, landscapeVideo, portraitVideo } = values;
  const mediaIds: number[] = [landscapeVideo.id];

  if (!isNil(portraitVideo) && landscapeVideo.id !== portraitVideo?.id) {
    mediaIds.push(portraitVideo.id);
  }

  return {
    avatarMediaId: avatarMedia.id,
    defaultMediaId: defaultMedia.id,
    emailMediaId: emailMedia.id,
    mediaIds,
  };
};



// WEBPACK FOOTER //
// ./view/components/create-event/helper/event-profile-request/event-media-details-request.helper.ts